import { SVGAttributes } from "react";

function InfraredIcon(props: SVGAttributes<HTMLOrSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 96 960 960"
      width="24"
      fill="currentColor"
    >
      <path d="m633.848 969.848-62.979-62.979q64.326-64.326 100.989-148.793Q708.521 673.609 708.521 576t-36.663-182.076q-36.663-84.467-100.989-148.793l62.979-62.979q75.761 75.761 119.522 176.663Q797.13 459.717 797.13 576t-43.76 217.185q-43.761 100.902-119.522 176.663ZM521.565 857.565l-62.978-62.978q42.565-42.565 66.728-98.652Q549.478 639.848 549.478 576t-24.163-119.935q-24.163-56.087-66.728-98.652l62.978-62.978q54 54 85.261 126.522Q638.087 493.478 638.087 576t-31.261 155.043q-31.261 72.522-85.261 126.522ZM409.283 745.283l-62.979-62.979q20.805-20.804 32.468-48.011 11.663-27.206 11.663-58.293t-11.663-58.293q-11.663-27.207-32.468-48.011l62.979-62.979q32 32 50.88 75.761 18.88 43.761 18.88 93.522t-18.88 93.522q-18.88 43.761-50.88 75.761ZM151.391 900.304V251.696H240V496q33 0 56.5 23.5T320 576q0 33-23.5 56.5T240 656v244.304h-88.609Z" />
    </svg>
  );
}

export default InfraredIcon;
